module.exports = __webpack_public_path__ + "img/library_bg.d486d292.png";